//import axios from 'axios';
//import { presetDefinitions } from '../../bay-ui/src/BayPolotno/sections/PageLayouts/presets/presetDefinitions';

// Mock API for presets that mimics real API structure
// This can be easily replaced with real API calls when backend is ready
const presets = () => {
	// Create root presets from social format templates
	const socialFormatTemplates = {
		Square: {
			width: 1080,
			height: 1080,
			importName: 'square',
			name: 'Square',
		},
		Portrait: {
			width: 1080,
			height: 1350,
			importName: '_1080x1350',
			name: 'Portrait',
		},
		Story: {
			width: 1080,
			height: 1920,
			importName: 'story',
			name: 'Story',
		},
		Landscape: {
			width: 1200,
			height: 627,
			importName: 'landscape',
			name: 'Landscape',
		},
	};

	// Create root social presets
	const rootSocialPresets = Object.entries(socialFormatTemplates).map(([key, template]) => ({
		id: key.toLowerCase(),
		_id: key.toLowerCase(),
		label: template.name,
		width: template.width,
		height: template.height,
		importName: template.importName,
		category: 'social',
		platform: 'root',
		type: 'image',
		presetComponent: key,
	}));

	// Create simplified print presets - one Flyer option + postcards
	const printPresets = [
		{
			id: 'flyer',
			_id: 'flyer',
			label: 'Flyer',
			width: 2550,
			height: 3300,
			importName: 'flyer',
			category: 'print',
			platform: 'flyer',
			type: 'image',
			presetComponent: 'FlyerPortraitSingleSided',
		},
		{
			id: 'postcard-standard',
			_id: 'postcard-standard',
			label: 'Postcard Standard',
			width: 1875,
			height: 1275,
			importName: 'postcardStandard',
			category: 'print',
			platform: 'postcard',
			type: 'image',
			presetComponent: 'PostcardStandard',
		},
		{
			id: 'postcard-jumbo',
			_id: 'postcard-jumbo',
			label: 'Postcard Jumbo',
			width: 2550,
			height: 1650,
			importName: 'postcardJumbo',
			category: 'print',
			platform: 'postcard',
			type: 'image',
			presetComponent: 'PostcardJumbo',
		}
	];

	// Combine root social presets with simplified print presets
	const rootPresets = [
		...rootSocialPresets,
		...printPresets
	];

	return {
		// Get all presets
		read: (queryParams = {}) => {
			return new Promise((resolve) => {
				// Simulate API delay
				setTimeout(() => {
					let filteredPresets = [...rootPresets];

					// Apply any filtering if needed
					if (queryParams.category) {
						filteredPresets = filteredPresets.filter(p => p.category === queryParams.category);
					}

					if (queryParams.platform) {
						filteredPresets = filteredPresets.filter(p => p.platform === queryParams.platform);
					}

					// Mock API response structure
					resolve({
						data: {
							result: filteredPresets,
							meta: {
								total: filteredPresets.length,
								limit: queryParams.limit || filteredPresets.length,
								offset: queryParams.offset || 0
							}
						}
					});
				}, 100); // Simulate network delay
			});
		},

		// Get preset by ID
		readById: (id) => {
			return new Promise((resolve, reject) => {
				setTimeout(() => {
					const preset = rootPresets.find(p => p._id === id || p.id === id);
					if (preset) {
						resolve({
							data: {
								result: preset
							}
						});
					} else {
						reject(new Error(`Preset with id ${id} not found`));
					}
				}, 50);
			});
		},

		// Get multiple presets by IDs
		readByIds: (ids) => {
			return new Promise((resolve) => {
				setTimeout(() => {
					const foundPresets = rootPresets.filter(p =>
						ids.includes(p._id) || ids.includes(p.id)
					);
					resolve({
						data: {
							result: foundPresets
						}
					});
				}, 100);
			});
		},

		// Get presets formatted for select options
		getSelectOptions: (queryParams = {}) => {
			return new Promise((resolve) => {
				setTimeout(() => {
					let filteredPresets = [...rootPresets];

					// Apply filtering
					if (queryParams.category) {
						filteredPresets = filteredPresets.filter(p => p.category === queryParams.category);
					}

					// Transform to select option format
					const options = filteredPresets.map(preset => ({
						value: preset._id,
						label: `${preset.label} (${preset.width}x${preset.height}px)`,
						...preset // Include all preset data for reference
					}));

					resolve({
						data: {
							result: options
						}
					});
				}, 100);
			});
		}
	};
};

const singleton = presets();
Object.freeze(singleton);

export default singleton;
